import React from 'react';
import { Form, InputNumber, Divider } from 'antd';
import { configShort } from '../../../../../common/utils/configFormField';

class Section5 extends React.Component {
  // constructor(props) {
  //     super(props);
  // }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields, disabledFields } = this.props;
    return (
      <div className="sectionDedlinePaid">
        <Divider />
        <h1 className="header">Срок оплаты</h1>
        <div className="colsLayout">
          <span className="label">
            Фактического пользования ТС
            <br />
            при отклонении от маршрута (С1), час:
          </span>
          <Form.Item>
            {getFieldDecorator('section5_1', configShort(fields['section5_1']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Фактического пользования ТС в сл. превыш. расчетного врем.
            <br />
            исп. ТС в связи с действиями орг. или пассажиров (С1), час:
          </span>
          <Form.Item>
            {getFieldDecorator('section5_2', configShort(fields['section5_2']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Компенсации дополнительных платежей (С1), час:
          </span>
          <Form.Item>
            {getFieldDecorator('section5_3', configShort(fields['section5_3']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Компенсации в случае одностороннего
            <br />
            отказа от договора (С1), час:
          </span>
          <Form.Item>
            {getFieldDecorator('section5_4', configShort(fields['section5_4']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Возврата фрахтовщиком ранее уплаченной в счет оказания
            <br />
            услуг суммы в сл. отказа от дог. в ходе оказания услуг (С1), час:
          </span>
          <Form.Item>
            {getFieldDecorator('section5_5', configShort(fields['section5_5']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default Section5;
